// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mst-page       { height: 100vh; display: flex; flex-direction: column; }
.mst-topbar     { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px; padding: 8px 12px; background: #fff; border-bottom: 1px solid #e9ecef; }
.mst-left       { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.mst-breadcrumb { display: flex; align-items: center; gap: 4px; font-size: 12px; }
.mst-bc-project { color: #6c757d; }
.mst-bc-sep     { color: #adb5bd; font-size: 10px; }
.mst-bc-ms      { font-weight: 700; color: #212529; }
.mst-right      { display: flex; align-items: center; gap: 8px; }
.mst-search     { height: 30px; font-size: 12px; width: 180px; padding-right: 24px; }
.mst-search-wrap{ position: relative; }
.mst-search-clear{ position: absolute; right: 6px; top: 50%; transform: translateY(-50%); cursor: pointer; }
.mst-board{
    height:calc(100vh - 165px);
    overflow-x:auto;
    overflow-y:hidden;
}
.mst-columns{
    display:flex;
    gap:14px;
    min-width:max-content;
    height:100%;
    align-items:stretch;
}
.mst-col        { flex: 1 1; min-width: 200px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e9ecef; padding: 8px; max-height: calc(100vh - 120px); overflow-y: auto; }
.mst-col-header { display: flex; justify-content: space-between; align-items: center; font-weight: 600; font-size: 13px; padding: 14px 8px; background: #fff; border-radius: 6px; margin-bottom: 8px; border-bottom: 2px solid #e9ecef; position: sticky; top: 0; z-index: 5; }
.mst-card       { background: #fff; border-radius: 10px; margin: 8px; padding: 10px 12px; margin-bottom: 8px; border: 1px solid white; border-left: 3px solid #dee2e6; box-shadow: 0 4px 12px rgba(0,0,0,0.06); cursor: grab; }
.mst-card:hover { border-color: #727cf5; }
.mst-card-badges{ display: flex; gap: 4px; align-items: center; margin-bottom: 6px; }
.mst-badge      { display: inline-flex; align-items: center; padding: 2px 6px; border-radius: 10px; font-size: 9px; font-weight: 800; text-transform: uppercase; }
.mst-summary    { font-size: 12px; font-weight: 600; color: rgba(0,0,0,0.77); margin-bottom: 4px; }
.mst-timeline   { font-size: 10px; font-weight: 700; color: #6c757d; }
.mst-card-foot  { display: flex; justify-content: space-between; align-items: center; margin-top: 8px; padding-top: 6px; border-top: 1px solid #f0f0f0; }
.mst-avatar     { width: 22px; height: 22px; border-radius: 50%; background: #0d6efd; color: #fff; font-size: 9px; font-weight: 700; display: flex; align-items: center; justify-content: center; }
.mst-due        { font-size: 9px; color: #adb5bd; }
.mst-empty-col  { display: flex; flex-direction: column; align-items: center; justify-content:  flex-start; padding-top: 30px; color: #adb5bd; font-size: 12px; }

.mst-list-wrap  { flex: 1 1; padding: 0 8px 8px; overflow-y: auto; }
.mst-list-fs    { font-size: 11px; }
.mst-list-badge { font-size: 10px; width: 100%; }
.form-select,
.form-control{
    height:44px;
    font-size:14px;
}

.card{
    border-radius:18px !important;
}

.btn-light{
    font-weight:600;
    transition:.25s;
}

.btn-light:hover{
    background:#0d6efd;
    color:#fff;
    border-color:#0d6efd;
}

.form-control:focus,
.form-select:focus{
    box-shadow:none;
    border-color:#0d6efd;
    
}

.card.shadow-sm{
    box-shadow:0 8px 25px rgba(0,0,0,.06)!important;
}
.milestone-toolbar{
    background:#fff;
 
    padding:12px 18px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    box-shadow:0 2px 10px rgba(0,0,0,.06);
    margin-bottom:18px;
}

.milestone-toolbar-left{
    display:flex;
    align-items:center;
    gap:12px;
}

.milestone-back-btn{
    height:30px;
    padding:0 14px;
    border:1px solid #dee2e6;
    border-radius:4px;
    background:#fff;
    display:flex;
    align-items:center;
    gap:6px;
    font-size:13px;
    font-weight:500;
    transition:.2s;
}

.milestone-back-btn:hover{
    background:#f8f9fa;
}

.milestone-filter{
    width:240px;
}

.milestone-search-box{
    width:230px;
    position:relative;
}

.milestone-search-input{
    width:100%;
    height:30px;
    border:1px solid #dee2e6;
    border-radius:4px;
    padding:0 12px 0 36px;
    font-size:13px;
}

.milestone-search-icon{
    position:absolute;
    left:12px;
    top:50%;
    transform:translateY(-50%);
    color:#6c757d;
    font-size:13px;
}














/* ========================== */

.mst-card{

    background:#fff;

    border-radius:14px;

    padding:14px;

    margin-bottom:12px;

    border:1px solid #ECEEF4;

    box-shadow:0 2px 8px rgba(0,0,0,.06);

    transition:.25s;
}

.mst-card:hover{

    transform:translateY(-2px);

    box-shadow:0 8px 18px rgba(0,0,0,.12);
}

/* ========================== */

.mst-card-top{

    display:flex;

    justify-content:space-between;

    align-items:flex-start;

    margin-bottom:10px;
}

.mst-card-badges{

    display:flex;

    gap:6px;
}

.mst-badge{

    padding:3px 8px;

    border-radius:20px;

    font-size:9px;

    font-weight:700;
}

.badge-overdue{

    background:#FFF3CD;

    color:#F59E0B;
}

.mst-card-date{

    font-size:11px;

    font-weight:600;

    color:#6B7280;
}

/* ========================== */

.mst-summary{

    font-size:14px;

    font-weight:500;

    color:#1F2937;

    line-height:1.4;

    margin-bottom:10px;
}

/* ========================== */

.mst-time-row{

    display:flex;

    justify-content:space-between;

    align-items:center;

    font-size:12px;

    margin-bottom:12px;
}

.mst-time-row strong{

    font-weight:600;
}

.mst-spent{

    color:#10B981;

    font-weight:600;
}

/* ========================== */

.mst-card-footer{

    display:flex;

    justify-content:space-between;

    align-items:center;
}

.mst-avatar{

    width:26px;

    height:26px;

    border-radius:50%;

    background:#7C3AED;

    color:#fff;

    display:flex;

    align-items:center;

    justify-content:center;

    font-size:10px;

    font-weight:700;
}

.mst-icons{

    display:flex;

    gap:12px;

    color:#6B7280;

    font-size:14px;
}

.mst-icons i{

    cursor:pointer;

    transition:.2s;
}

.mst-icons i:hover{
    color:#7C3AED;
}

/* Responsive Rules for MilestoneTasks */
@media (max-width: 768px) {
    .milestone-toolbar {
        flex-direction: column;
        align-items: stretch !important;
        gap: 10px;
        padding: 10px 14px;
    }

    .mst-topbar {
        flex-direction: column;
        align-items: stretch !important;
        gap: 8px;
    }

    .mst-search {
        width: 100% !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/MilestoneTasks.css"],"names":[],"mappings":"AAAA,kBAAkB,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE;AACxE,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,eAAe,EAAE,QAAQ,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gCAAgC,EAAE;AACxL,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACjF,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACjF,kBAAkB,cAAc,EAAE;AAClC,kBAAkB,cAAc,EAAE,eAAe,EAAE;AACnD,kBAAkB,gBAAgB,EAAE,cAAc,EAAE;AACpD,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChE,kBAAkB,YAAY,EAAE,eAAe,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACpF,kBAAkB,kBAAkB,EAAE;AACtC,mBAAmB,kBAAkB,EAAE,UAAU,EAAE,QAAQ,EAAE,2BAA2B,EAAE,eAAe,EAAE;AAC3G;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,QAAQ;IACR,qBAAqB;IACrB,WAAW;IACX,mBAAmB;AACvB;AACA,kBAAkB,SAAO,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,YAAY,EAAE,+BAA+B,EAAE,gBAAgB,EAAE;AAClL,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gCAAgC,EAAE,gBAAgB,EAAE,MAAM,EAAE,UAAU,EAAE;AAC9Q,kBAAkB,gBAAgB,EAAE,mBAAmB,EAAE,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,uCAAuC,EAAE,YAAY,EAAE;AAC9N,kBAAkB,qBAAqB,EAAE;AACzC,kBAAkB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACpF,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AACjK,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AAClG,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrE,kBAAkB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,6BAA6B,EAAE;AACxJ,kBAAkB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE,cAAc,EAAE,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAClM,kBAAkB,cAAc,EAAE,cAAc,EAAE;AAClD,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEhK,kBAAkB,SAAO,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACjE,kBAAkB,eAAe,EAAE;AACnC,kBAAkB,eAAe,EAAE,WAAW,EAAE;AAChD;;IAEI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;IACf,oBAAoB;;AAExB;;AAEA;IACI,+CAA+C;AACnD;AACA;IACI,eAAe;;IAEf,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,wBAAwB;IACxB,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,OAAO;IACP,0BAA0B;IAC1B,aAAa;IACb,cAAc;AAClB;;;;;;;;;;;;;;;AAeA,+BAA+B;;AAE/B;;IAEI,eAAe;;IAEf,kBAAkB;;IAElB,YAAY;;IAEZ,kBAAkB;;IAElB,wBAAwB;;IAExB,oCAAoC;;IAEpC,eAAe;AACnB;;AAEA;;IAEI,0BAA0B;;IAE1B,qCAAqC;AACzC;;AAEA,+BAA+B;;AAE/B;;IAEI,YAAY;;IAEZ,6BAA6B;;IAE7B,sBAAsB;;IAEtB,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;;IAEZ,OAAO;AACX;;AAEA;;IAEI,eAAe;;IAEf,kBAAkB;;IAElB,aAAa;;IAEb,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;;IAElB,aAAa;AACjB;;AAEA;;IAEI,cAAc;;IAEd,eAAe;;IAEf,aAAa;AACjB;;AAEA,+BAA+B;;AAE/B;;IAEI,cAAc;;IAEd,eAAe;;IAEf,aAAa;;IAEb,eAAe;;IAEf,kBAAkB;AACtB;;AAEA,+BAA+B;;AAE/B;;IAEI,YAAY;;IAEZ,6BAA6B;;IAE7B,kBAAkB;;IAElB,cAAc;;IAEd,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,aAAa;;IAEb,eAAe;AACnB;;AAEA,+BAA+B;;AAE/B;;IAEI,YAAY;;IAEZ,6BAA6B;;IAE7B,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;;IAEV,WAAW;;IAEX,iBAAiB;;IAEjB,kBAAkB;;IAElB,UAAU;;IAEV,YAAY;;IAEZ,kBAAkB;;IAElB,sBAAsB;;IAEtB,cAAc;;IAEd,eAAe;AACnB;;AAEA;;IAEI,YAAY;;IAEZ,QAAQ;;IAER,aAAa;;IAEb,cAAc;AAClB;;AAEA;;IAEI,cAAc;;IAEd,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA,wCAAwC;AACxC;IACI;QACI,sBAAsB;QACtB,+BAA+B;QAC/B,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,+BAA+B;QAC/B,QAAQ;IACZ;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".mst-page       { height: 100vh; display: flex; flex-direction: column; }\n.mst-topbar     { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px; padding: 8px 12px; background: #fff; border-bottom: 1px solid #e9ecef; }\n.mst-left       { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\n.mst-breadcrumb { display: flex; align-items: center; gap: 4px; font-size: 12px; }\n.mst-bc-project { color: #6c757d; }\n.mst-bc-sep     { color: #adb5bd; font-size: 10px; }\n.mst-bc-ms      { font-weight: 700; color: #212529; }\n.mst-right      { display: flex; align-items: center; gap: 8px; }\n.mst-search     { height: 30px; font-size: 12px; width: 180px; padding-right: 24px; }\n.mst-search-wrap{ position: relative; }\n.mst-search-clear{ position: absolute; right: 6px; top: 50%; transform: translateY(-50%); cursor: pointer; }\n.mst-board{\n    height:calc(100vh - 165px);\n    overflow-x:auto;\n    overflow-y:hidden;\n}\n.mst-columns{\n    display:flex;\n    gap:14px;\n    min-width:max-content;\n    height:100%;\n    align-items:stretch;\n}\n.mst-col        { flex: 1; min-width: 200px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e9ecef; padding: 8px; max-height: calc(100vh - 120px); overflow-y: auto; }\n.mst-col-header { display: flex; justify-content: space-between; align-items: center; font-weight: 600; font-size: 13px; padding: 14px 8px; background: #fff; border-radius: 6px; margin-bottom: 8px; border-bottom: 2px solid #e9ecef; position: sticky; top: 0; z-index: 5; }\n.mst-card       { background: #fff; border-radius: 10px; margin: 8px; padding: 10px 12px; margin-bottom: 8px; border: 1px solid white; border-left: 3px solid #dee2e6; box-shadow: 0 4px 12px rgba(0,0,0,0.06); cursor: grab; }\n.mst-card:hover { border-color: #727cf5; }\n.mst-card-badges{ display: flex; gap: 4px; align-items: center; margin-bottom: 6px; }\n.mst-badge      { display: inline-flex; align-items: center; padding: 2px 6px; border-radius: 10px; font-size: 9px; font-weight: 800; text-transform: uppercase; }\n.mst-summary    { font-size: 12px; font-weight: 600; color: rgba(0,0,0,0.77); margin-bottom: 4px; }\n.mst-timeline   { font-size: 10px; font-weight: 700; color: #6c757d; }\n.mst-card-foot  { display: flex; justify-content: space-between; align-items: center; margin-top: 8px; padding-top: 6px; border-top: 1px solid #f0f0f0; }\n.mst-avatar     { width: 22px; height: 22px; border-radius: 50%; background: #0d6efd; color: #fff; font-size: 9px; font-weight: 700; display: flex; align-items: center; justify-content: center; }\n.mst-due        { font-size: 9px; color: #adb5bd; }\n.mst-empty-col  { display: flex; flex-direction: column; align-items: center; justify-content:  flex-start; padding-top: 30px; color: #adb5bd; font-size: 12px; }\n\n.mst-list-wrap  { flex: 1; padding: 0 8px 8px; overflow-y: auto; }\n.mst-list-fs    { font-size: 11px; }\n.mst-list-badge { font-size: 10px; width: 100%; }\n.form-select,\n.form-control{\n    height:44px;\n    font-size:14px;\n}\n\n.card{\n    border-radius:18px !important;\n}\n\n.btn-light{\n    font-weight:600;\n    transition:.25s;\n}\n\n.btn-light:hover{\n    background:#0d6efd;\n    color:#fff;\n    border-color:#0d6efd;\n}\n\n.form-control:focus,\n.form-select:focus{\n    box-shadow:none;\n    border-color:#0d6efd;\n    \n}\n\n.card.shadow-sm{\n    box-shadow:0 8px 25px rgba(0,0,0,.06)!important;\n}\n.milestone-toolbar{\n    background:#fff;\n \n    padding:12px 18px;\n    display:flex;\n    justify-content:space-between;\n    align-items:center;\n    box-shadow:0 2px 10px rgba(0,0,0,.06);\n    margin-bottom:18px;\n}\n\n.milestone-toolbar-left{\n    display:flex;\n    align-items:center;\n    gap:12px;\n}\n\n.milestone-back-btn{\n    height:30px;\n    padding:0 14px;\n    border:1px solid #dee2e6;\n    border-radius:4px;\n    background:#fff;\n    display:flex;\n    align-items:center;\n    gap:6px;\n    font-size:13px;\n    font-weight:500;\n    transition:.2s;\n}\n\n.milestone-back-btn:hover{\n    background:#f8f9fa;\n}\n\n.milestone-filter{\n    width:240px;\n}\n\n.milestone-search-box{\n    width:230px;\n    position:relative;\n}\n\n.milestone-search-input{\n    width:100%;\n    height:30px;\n    border:1px solid #dee2e6;\n    border-radius:4px;\n    padding:0 12px 0 36px;\n    font-size:13px;\n}\n\n.milestone-search-icon{\n    position:absolute;\n    left:12px;\n    top:50%;\n    transform:translateY(-50%);\n    color:#6c757d;\n    font-size:13px;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* ========================== */\n\n.mst-card{\n\n    background:#fff;\n\n    border-radius:14px;\n\n    padding:14px;\n\n    margin-bottom:12px;\n\n    border:1px solid #ECEEF4;\n\n    box-shadow:0 2px 8px rgba(0,0,0,.06);\n\n    transition:.25s;\n}\n\n.mst-card:hover{\n\n    transform:translateY(-2px);\n\n    box-shadow:0 8px 18px rgba(0,0,0,.12);\n}\n\n/* ========================== */\n\n.mst-card-top{\n\n    display:flex;\n\n    justify-content:space-between;\n\n    align-items:flex-start;\n\n    margin-bottom:10px;\n}\n\n.mst-card-badges{\n\n    display:flex;\n\n    gap:6px;\n}\n\n.mst-badge{\n\n    padding:3px 8px;\n\n    border-radius:20px;\n\n    font-size:9px;\n\n    font-weight:700;\n}\n\n.badge-overdue{\n\n    background:#FFF3CD;\n\n    color:#F59E0B;\n}\n\n.mst-card-date{\n\n    font-size:11px;\n\n    font-weight:600;\n\n    color:#6B7280;\n}\n\n/* ========================== */\n\n.mst-summary{\n\n    font-size:14px;\n\n    font-weight:500;\n\n    color:#1F2937;\n\n    line-height:1.4;\n\n    margin-bottom:10px;\n}\n\n/* ========================== */\n\n.mst-time-row{\n\n    display:flex;\n\n    justify-content:space-between;\n\n    align-items:center;\n\n    font-size:12px;\n\n    margin-bottom:12px;\n}\n\n.mst-time-row strong{\n\n    font-weight:600;\n}\n\n.mst-spent{\n\n    color:#10B981;\n\n    font-weight:600;\n}\n\n/* ========================== */\n\n.mst-card-footer{\n\n    display:flex;\n\n    justify-content:space-between;\n\n    align-items:center;\n}\n\n.mst-avatar{\n\n    width:26px;\n\n    height:26px;\n\n    border-radius:50%;\n\n    background:#7C3AED;\n\n    color:#fff;\n\n    display:flex;\n\n    align-items:center;\n\n    justify-content:center;\n\n    font-size:10px;\n\n    font-weight:700;\n}\n\n.mst-icons{\n\n    display:flex;\n\n    gap:12px;\n\n    color:#6B7280;\n\n    font-size:14px;\n}\n\n.mst-icons i{\n\n    cursor:pointer;\n\n    transition:.2s;\n}\n\n.mst-icons i:hover{\n    color:#7C3AED;\n}\n\n/* Responsive Rules for MilestoneTasks */\n@media (max-width: 768px) {\n    .milestone-toolbar {\n        flex-direction: column;\n        align-items: stretch !important;\n        gap: 10px;\n        padding: 10px 14px;\n    }\n\n    .mst-topbar {\n        flex-direction: column;\n        align-items: stretch !important;\n        gap: 8px;\n    }\n\n    .mst-search {\n        width: 100% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
